import React, { useState } from "react";
import './qualification.css'

const Qualification = ({ isDarkMode }) => {
    const bodyClass = `qualification section ${isDarkMode ? "dark-mode" : ""}`;

    const [toggleState, setToggleState] = useState(2);

    const toggleTab = (index) => {
        setToggleState(index);
    }
    return (
        <section className={bodyClass} id="qualification">
            <h2 className="section__title">Qualification</h2>
            <span className="section__subtitle">My Qualifications</span>

            <div className="qualification__container container">
                <div className="qualification__tabs">

                    <div className={toggleState === 2
                        ? "qualification__button qualification__active button--flex"
                        : "qualification__button button--flex"}
                        onClick={() => toggleTab(2)}>
                        <i className="uil uil-briefcase-alt qualification__icon"></i>{" "} Experience
                    </div>

                    <div className={toggleState === 1
                        ? "qualification__button qualification__active button--flex"
                        : "qualification__button button--flex"}
                        onClick={() => toggleTab(1)}>
                        <i className="uil uil-graduation-cap qualification__icon"></i>{" "} Education
                    </div>
                </div>

                <div className="qualification__sections">
                    <div className={toggleState === 1
                        ? "qualification__content qualification__content-active"
                        : "qualification__content"}>
                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">Bsc Computer Science</h3>
                                <span className="qualification__subtitle">University of Mumbai</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calender"></i> 2021 - 2024
                                </div>
                            </div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>

                        <div className="qualification__data">
                            <div></div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>

                            <div>
                                <h3 className="qualification__title">High School Certificate (HSC)</h3>
                                <span className="qualification__subtitle">Tilak College</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calender"></i> 2018 - 2020
                                </div>
                            </div>


                        </div>

                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">Secondary School Certificate (SSC)</h3>
                                <span className="qualification__subtitle">Maharashtra Board</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calender"></i> 2018
                                </div>
                            </div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>

                            <div></div>


                        </div>


                    </div>

                    <div className={toggleState === 2
                        ? "qualification__content qualification__content-active"
                        : "qualification__content"}>

                        <div className="qualification__data">


                            <div>
                                <h3 className="qualification__title">Software Engineer</h3>
                                <span className="qualification__subtitle">Unico Connect LLP</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calender"></i> Jan 2024 - Present
                                </div>
                            </div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>

                            <div></div>


                        </div>

                        <div className="qualification__data">
                            <div></div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>

                            <div>
                                <h3 className="qualification__title">Front End Intern</h3>
                                <span className="qualification__subtitle">Destino Infortech</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calender"></i> June 2023 - Jan 2024
                                </div>
                            </div>
                        </div>

                        <div className="qualification__data">


                            <div>
                                <h3 className="qualification__title">Full Stack Engineer</h3>
                                <span className="qualification__subtitle">Freelance</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calender"></i>  Jan 2023 - May 2024
                                </div>

                            </div>

                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>

                            <div></div>


                        </div>
                    </div>


                </div>
            </div>
        </section>
    )
}

export default Qualification
